import { render, staticRenderFns } from "./pedidosInternos_panelLateral.vue?vue&type=template&id=101a49a0&scoped=true"
import script from "./pedidosInternos_panelLateral.vue?vue&type=script&lang=js"
export * from "./pedidosInternos_panelLateral.vue?vue&type=script&lang=js"
import style0 from "./pedidosInternos_panelLateral.vue?vue&type=style&index=0&id=101a49a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a49a0",
  null
  
)

export default component.exports